import '@fontsource-variable/montserrat';
import './styles/index.css';
import { startApp } from './app';
import { imageCacheService } from './services/image-cache-service';
import { kioskRuntime } from './services/runtime-config';

document.documentElement.style.setProperty('--kiosk-welcome-placeholder', `url("${kioskRuntime.publicPath('/images/menu/0.webp')}")`);
document.documentElement.style.setProperty('--kiosk-age-gate', `url("${kioskRuntime.publicPath('/images/bar-menu-age-gate.png')}")`);
document.documentElement.style.setProperty('--kiosk-age-gate-mobile', `url("${kioskRuntime.publicPath('/images/bar-menu-age-gate-mobile.png')}")`);

if ('serviceWorker' in navigator) window.addEventListener('load', async () => {
  const registration = await navigator.serviceWorker.register('./service-worker.js', { updateViaCache: 'none' });
  await registration.update();
});
void imageCacheService.init().catch(() => undefined).finally(() => { void startApp(); });
